module.exports = __webpack_public_path__ + "media/images/assignment/open_in_new-4dc04e205ee14f79b69fe396804f2d82.svg";